import { Check } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHero, CTABand } from "../components/PageSections";
import { Eyebrow, Reveal } from "../components/ui-bits";

export function ServicePage({ page }) {
  return (
    <>
      <Seo title={page.seoTitle} description={page.seoDescription} />
      <PageHero
        eyebrow={page.eyebrow}
        lines={page.title}
        lede={page.lede}
        image={page.image}
        imageAlt={page.imageAlt}
        secondary={{ href: "/gallery", label: "See the Gallery", testid: "hero-gallery-link" }}
      />

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <div className="grid items-start gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <Eyebrow>From the Design Bench</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl font-medium leading-snug text-plum sm:text-4xl">
              {page.introTitle}
            </h2>
            {page.paragraphs.map((p, i) => (
              <p key={i} className="mt-5 text-[17px] leading-relaxed text-charcoal/85">
                {p}
              </p>
            ))}
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full rounded-xl border border-gold/50" aria-hidden="true" />
              <img
                src={page.image}
                alt={page.imageAlt}
                loading="lazy"
                className="relative aspect-[4/5] w-full rounded-xl object-cover shadow-xl shadow-sage/15"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-sagetint">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
          <Reveal>
            <Eyebrow>Good to Know</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl font-medium text-plum sm:text-4xl">{page.bulletsTitle}</h2>
          </Reveal>
          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {page.bullets.map((b, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex items-start gap-4 rounded-xl bg-ivory p-6 shadow-sm">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-plum/10">
                    <Check className="h-4 w-4 text-plum" strokeWidth={3} aria-hidden="true" />
                  </span>
                  <p className="text-[16px] leading-relaxed text-charcoal/90">{b}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 py-20 text-center sm:px-8">
        <Reveal>
          <h2 className="font-serif text-3xl font-medium text-plum sm:text-4xl">{page.closingTitle}</h2>
          <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-charcoal/85">{page.closing}</p>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
